import React, { useRef } from "react";
import { PDFDownloadLink } from "@react-pdf/renderer";
import PrimaryButton from "../../../materialCommitment/buttons/PrimaryButton";
import SecondaryButton from "../../../materialCommitment/buttons/SecondaryButton";
import { isMaterialOrGD } from "../../../materialCommitment/helpers/Categories";
import ReportDoc from "../../../printable/ReportToPDF";
import { fillAllFieldsBeforeDownloadNotification } from "../../../materialCommitment/helpers/Notifications";

const ReportActionsContainer = ({
  commitment,
  saveReport,
  operation,
  startingDate,
  endingDate,
  progress,
  meters,
  reportText,
  editing,
  validateReport
}) => {
  if (!editing && isMaterialOrGD(commitment.commitmentType)) return null;
  const downloadPdfLinkRef = useRef(null);

  //Before downloading the pdf, validate that all fields are filled. If all fields are filled, trigger a PDFDownloadLink via a ref.
  const handlePdfDownload = () => {
    if (!validateReport()) return fillAllFieldsBeforeDownloadNotification();
    if (downloadPdfLinkRef.current) {
      downloadPdfLinkRef.current.click();
    }
  };

  return (
    <div className="flex-row items-center space-between">
      <PrimaryButton
        textKey={"sit.profile.operationReport.publishReport"}
        action={() => saveReport("approved")}
      />

      <button
        style={{
          fontSize: "16px",
          fontWeight: 700,
          color: "#93be38",
          border: "none",
          background: "none"
        }}
        onClick={() => handlePdfDownload()}
      >
        Lataa raportti
      </button>

      <PDFDownloadLink
        style={{ display: "none" }}
        document={
          <ReportDoc
            commitment={commitment}
            author={commitment.organizationName}
            operation={operation}
            meters={meters}
            startingDate={startingDate}
            endingDate={endingDate}
            progress={progress}
            reportText={reportText}
          />
        }
        fileName="raportti.pdf"
      >
        {({ blob, url, loading, error }) => <button ref={downloadPdfLinkRef} />}
      </PDFDownloadLink>
    </div>
  );
};

export default ReportActionsContainer;



// WEBPACK FOOTER //
// ./src/components/profile/reports/components/ReportActionsContainer.jsx